import { useMemo } from 'react';
import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useSlots() {
  const {
    state: { controlPanelMode, draftCrop, selectedSlotIndex, slotCount, slots },
  } = useEditSceneModalStateContext();

  const slotsToDraw = useMemo(() => {
    const result = slots?.slice(0, slotCount);

    if (result === undefined) {
      return [];
    }

    if (
      selectedSlotIndex >= 0 &&
      selectedSlotIndex < result.length &&
      // probably don't need both of these checks...if keeping just one, draftCrop
      // is probably safer
      controlPanelMode === 'adjust-crop' &&
      draftCrop !== undefined
    ) {
      result[selectedSlotIndex] = {
        ...result[selectedSlotIndex],
        staticCrop: draftCrop,
      };
    }

    return result;
  }, [controlPanelMode, draftCrop, selectedSlotIndex, slotCount, slots]);

  return { slots: slotsToDraw };
}
